import { render } from "./SideMenuPrincipal.vue?vue&type=template&id=69a44cf5"
import script from "./SideMenuPrincipal.vue?vue&type=script&lang=js"
export * from "./SideMenuPrincipal.vue?vue&type=script&lang=js"

import "./SideMenuPrincipal.vue?vue&type=style&index=0&id=69a44cf5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__